import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ActivityEventRowType, SystemState } from 'features/system/systemTypes';

const initialState: SystemState = {
  activityEvents: []
};

const systemSlice = createSlice({
  name: 'system',
  initialState,
  reducers: {
    setActivityEventsList(
      state,
      action: PayloadAction<ActivityEventRowType[]>
    ) {
      state.activityEvents = action.payload;
    }
  }
});

export const { setActivityEventsList } = systemSlice.actions;

export const system = systemSlice.reducer;
